export default __webpack_public_path__ + "static/media/with-plugin.eb189e93.gif";